import styled from "styled-components";
import SpinnerBase from "./SpinnerBase";

const ContainerDiv = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
`;

interface IProps {
  visible: boolean;
}

const MapLoadingSpinner = ({ visible }: IProps) => {
  if (visible) {
    return (
      <ContainerDiv>
        <SpinnerBase />
      </ContainerDiv>
    );
  } else {
    return <ContainerDiv />;
  }
};

export default MapLoadingSpinner;
